"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvatarMenuOptions = void 0;
const react_1 = __importStar(require("react"));
const material_1 = require("@mui/material");
var AvatarMenuOptions;
(function (AvatarMenuOptions) {
    AvatarMenuOptions["Logout"] = "Logout";
    AvatarMenuOptions["Profile"] = "Profile";
})(AvatarMenuOptions = exports.AvatarMenuOptions || (exports.AvatarMenuOptions = {}));
const AvatarMenu = ({ children, anchorEl, open, onClose, logout, cache, }) => {
    const [logoutText, setLogoutText] = (0, react_1.useState)(AvatarMenuOptions.Logout);
    return (react_1.default.createElement(material_1.Menu, { id: "user-menu", anchorEl: anchorEl, keepMounted: true, open: open, onClose: onClose, variant: "selectedMenu", anchorOrigin: {
            vertical: "bottom",
            horizontal: "left",
        }, transformOrigin: {
            vertical: "top",
            horizontal: "center",
        } },
        react_1.default.createElement(material_1.MenuItem, null,
            react_1.default.createElement(material_1.Link, { href: `${process.env.REACT_APP_PORTAL_URL}/profile`, target: "_blank", rel: "noopener noreferrer", style: { textDecoration: "none" } }, AvatarMenuOptions.Profile)),
        react_1.default.createElement(material_1.MenuItem, { onClick: async () => {
                setLogoutText("Securely logging out and clearing session...");
                await logout();
                const keys = await cache.keys();
                keys.forEach((key) => cache.delete(key));
            } }, logoutText),
        children));
};
exports.default = AvatarMenu;
